/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * moovy-saas-api
 * OpenAPI spec version: 1.0.0
 */

/**
 * 見えるボタンのスタイル（ADR-0024）。SOLID=塗り / OUTLINE=枠線 / GLASS=半透明
 */
export type HotspotButtonVariant = (typeof HotspotButtonVariant)[keyof typeof HotspotButtonVariant]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HotspotButtonVariant = {
  SOLID: 'SOLID',
  OUTLINE: 'OUTLINE',
  GLASS: 'GLASS',
} as const
